module.exports = __webpack_public_path__ + "catalog/items/firesafety/exit-stairs-down/exit-stairs-down.svg";